<div class="row pt-6 px-2 pb-4 pb-sm-9">
  <div class="header-container col-sm">
    <span class="icon-contributors"></span>
    <h3 class="title" data-automation-id="contributors-title">
      <ng-container *ngIf="entity.entityType === AGENT">{{ 'contributorsTitleRelatedPeople' | translate }}</ng-container>
      <ng-container *ngIf="entity.entityType !== AGENT">{{ 'contributors' | translate }}</ng-container>
    </h3>
  </div>
  <app-see-all-button class="col-auto" *ngIf="!isLoading && totalCount > 1" seeAllType="see-all-contributors"
    [url]="['/search', 'card']"
    [queryParams]="{
      id: entity.id,
      entityType: entity.entityType,
      showcase: CONTRIBUTORS,
      identifier: identifier,
      showcaseId: showcaseId || null
    }">
    <span data-automation-id="contributors-see-all-text">
      <ng-container *ngIf="entity.entityType === AGENT">
        {{ 'seeAll' | translate }} {{ totalCount }} {{ 'contributorsTitleRelatedPeople' | translate }}
      </ng-container>
      <ng-container *ngIf="entity.entityType !== AGENT">
        {{ 'seeAll' | translate }} {{ totalCount }} {{ 'contributors' | translate }}
      </ng-container>
    </span>
  </app-see-all-button>
</div>

<div class="contributors-content-row d-flex justify-content-between px-2 pb-4 pb-sm-9">
  <button class="carousel-btn ins-buttons button-primary left align-self-center"
    (click)="switchCarouselLeft($event)"
    data-automation-id="carousel-left-btn"
    aria-label="Move to the previous contributor"
    [disabled]="!isLeftSwitchAvailable"
    [ngClass]="{'cdk-visually-hidden': !isLeftSwitchAvailable}"
    [attr.aria-disabled]="!isLeftSwitchAvailable"
    (mouseenter)="toggleMouseEvent(true)"
    (mouseleave)="toggleMouseEvent(false)">
    <fa-icon class="arrow-icon" [icon]="arrowIconLeft"></fa-icon>
  </button>
  <ul class="items row mx-4 mb-0 flex-fill list-unstyled">
    <li class="item col-sm-6 col-md-3"
         *ngFor="let contributor of carouselItems; let last = last; let i = index"
         [ngClass]="{'item-last': last}">
      <app-contributor
        [contributor]="contributor"
        [focusedId]="focusedId"
        [isMouseEvent]="isMouseEvent"
        [index]="i"
        [identifier]="identifier">
      </app-contributor>
    </li>
    <div *ngIf="isLoading" class="item item-loading" data-automation-id="contributors-spinner">
      <div class="loading-spinner">
        <div class="spinner-border text-primary item-loading-spinner"
                role="status"
                aria-live="polite">
                <span class="sr-only" translate>
                    Loading...
                </span>
        </div>
      </div>
    </div>
  </ul>
  <button
    class="carousel-btn ins-buttons button-primary right align-self-center"
    *ngIf="isRightSwitchAvailable && !isLoading"
    (click)="switchCarouselRight($event)"
    data-automation-id="carousel-right-btn"
    aria-label="Move to the next contributor"
    (mouseenter)="toggleMouseEvent(true)"
    (mouseleave)="toggleMouseEvent(false)">
    <fa-icon class="arrow-icon" [icon]="arrowIconRight"></fa-icon>
  </button>
</div>
